<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="门店信息"
      title="门店信息"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
    <HpsfirProForm :is-dialog="true" ref="bindWxFormRef" title="绑定公众号" :items="bindWxItems" @ok="handleBindWxOk"/>
    <qrcode ref="qrcodeRef"  />
    <nfc ref="nfcRef" />
  </div>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  useBaseOperateStore,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { computed, ref } from 'vue';
import { getTodaySec, todaySecFormat, todaySecToDayjs } from '@/utils';
import dayjs from 'dayjs';
import qrcode from './qrcode.vue';
import nfc from './nfc.vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const bindWxFormRef = ref<any>();
const qrcodeRef = ref<InstanceType<typeof qrcode>>();
const nfcRef = ref<InstanceType<typeof nfc>>();
const bindWxItems = ref<HpsfirProFormItem[]>([]);

const baseOperateStore = useBaseOperateStore();

const loading = ref(false);
const addInitValue = {
  startTime: dayjs('2000-01-01 00:00:00').toDate(),
  endTime: dayjs('2000-01-01 00:00:00').toDate(),
};
const conditionsInitValue = {
  openWhite: undefined,
};
const currentRow = ref<any>();
const faOptions = ref<{
  value: any;
  label: string;
}[]>([]);

// 可管理服务商，则是管理员
const canAdminFacilitator = computed(() => baseOperateStore.operates?.find((item) => item.key === 'ADMIN_STORE_FACILITATOR'));

// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(async() => {
  const res = await useApi().deviceApi.listDeviceTypeDevice();
  const options = res.data.data?.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));

  if (canAdminFacilitator.value) {
    const faRes = await useApi().facilitatorApi.listFacilitatorfacilitator({ conditions: {} });
    faOptions.value = faRes.data.data?.map((item: any) => ({
      value: item.id,
      label: item.name,
    })) || [];
  }


  columns.value = normalizeBizTableColumns([
    {
      name: 'name',
      label: '店铺名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    ...(
      canAdminFacilitator.value ? [
        {
          name: 'remark',
          label: '设备备注',
          type: 'string',
          isCondition: true,
          isSearch: true,
          hideEdit: true,
          hideCreate: true,
          order: 10,
        },
      ] : []
    ) as any,

    {
      name: 'deviceIdHex',
      label: '设备序列号',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    ...(
      canAdminFacilitator.value ? [
        {
          name: 'deviceTypeId',
          label: '设备类型',
          type: 'select',
          options,
          rule: [{ required: true }],
          isCondition: true,
          hideEdit: true,
          hideCreate: true,
          render: (scope: any) => {
            const deviceTypeId = scope?.row?.deviceTypeId;
            const deviceType = options.find((item: any) => item.value === deviceTypeId);
            if (!deviceType) {
              return '-';
            }
            return deviceType.label;
          },
        },
      ] : []
    ) as any,

    {
      name: 'phone',
      label: '店主手机号',
      type: 'string',
      rule: [{ required: true }],
      isCondition: true,
    },
    {
      name: 'storeType',
      label: '店铺类型',
      type: 'select',
      options: [
        { label: '通用', value: 'GENERAL' },
        { label: '快递', value: 'EXPRESS' },
      ],
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'openWhite',
      label: '是否开启白名单',
      type: 'swtich',
      trueText: '开启',
      falseText: '关闭',
      isCondition: true,
      hideCreate: true,
    },

    {
      name: 'status',
      label: '设备状态',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },

    {
      name: 'packageEndTime',
      label: '套餐到期时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
  ]);
});

const operates = [

  {
    key: 'opendoor',
    name: '远程开门',
    handler: useBaseAsync(async(row: any) => {
      await useApi().deviceApi.deviceAdminOpendoorHexDevice(row.deviceIdHex);
      ElMessage.success('成功');
      tableRef.value?.refresh();
    }),
  },

  {
    key: 'getNfcUrl',
    name: '获取NFC URL',
    handler: useBaseAsync(async(row: any) => {
      await nfcRef.value?.show(row.id);
    }),
  },

  /* {
    key: 'getQrcode',
    name: '获取一店一码（）',
    handler: useBaseAsync(async(row: any) => {
      if (!row.wxAppid) {
        ElMessage.warning('请先绑定公众号！');
        return;
      }
      try {
        loading.value = true;
        await qrcodeRef.value?.show(row);
      } finally {
        loading.value = false;
      }
    }),
  }, */

];


// eslint-disable-next-line max-lines-per-function
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().storeApi.pageStorestore({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    tableData.data = tableData.data.map((item) => {
      const statusRef = ref('加载中...');

      useApi()
        .deviceApi.deviceStatusHexDevice(item.deviceIdHex, {
          headers: {
            'custom-error': 'true',
          },
        })
        .then((statusRes) => {
          if (typeof statusRes.data.data === 'boolean') {
            statusRef.value = statusRes.data.data ? '在线' : '离线';
          } else {
            // 字符形式返回的状态
            statusRef.value = statusRes.data.data;
          }
        })
        .catch(() => {
          statusRef.value = '-';
        });

      return {
        ...item,
        status: statusRef,
      };
    });
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;

const normalizeStorePayload = (data: any) => {
  const payload = { ...data };
  delete payload.startTime;
  delete payload.endTime;
  return {
    ...payload,
    phone: data.phone === undefined || data.phone === null ? data.phone : String(data.phone),
    start: 0,
    end: 0,
    facilitatorId: undefined,
    facilitatorName: undefined,
  };
};


const addFun = useBaseAsync(async(data: any) => {
  await useApi().storeApi.addStorestore({
    storeAdminVo: normalizeStorePayload(data),
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().storeApi.updateStorestore({
    storeAdminVo: normalizeStorePayload(data),
  });
  ElMessage.success('修改成功');
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().storeApi.delStorestore(data.id);
  ElMessage.success('删除成功');
});

const handleBindWxOk = useBaseAsync(async(data: any) => {
  await useApi().storeApi.bindWxstore({
    storeId: currentRow.value.id,
    appid: data.wxAppid,
  });
  ElMessage.success('绑定成功');
  tableRef.value?.refresh();
});


init();

</script>
<style lang="scss" scoped>
</style>
